import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
import { __rest as t } from "../_virtual/_tslib.js";
import { jsx as e, jsxs as i, Fragment as n } from "react/jsx-runtime";
import a, { css as o } from "styled-components";
import { calculateRem as r, hexToRgba as c, generateUUID as l, getNodeText as s } from "@vds-core/utilities";
import { TextLink as d } from "@vds-core/buttons";
import { Checkbox as u } from "@vds-core/checkboxes";
import { AccessibilityTokens as p } from "@vds-tokens/accessibility";
import { LayoutTokens as m } from "@vds-tokens/layout";
import { ColorTokens as h } from "@vds-tokens/color";
import { Line as f } from "@vds-core/lines";
import { Toggle as g } from "@vds-core/toggles";
import { Fonts as b, Body as v } from "@vds-core/typography";
import { TypographyTokens as k } from "@vds-tokens/typography";
import { Icon as $ } from "@vds-core/icons";
import { ButtonIcon as y } from "@vds-core/button-icons";
import { createElement as I, Component as _, Children as x, cloneElement as w, isValidElement as C } from "react";
var S = r(m.space["6X"].value),
  L = r(m.space["8X"].value),
  T = r(m.space["3X"].value),
  E = r(m.space["4X"].value),
  z = r(m.space["4X"].value),
  D = r(m.space["6X"].value),
  M = r(m.space["1X"].value),
  W = function W(t) {
    return {
      hover: h.elements.primary["on".concat(t)].value,
      active: h.interactive.active["on".concat(t)].value
    };
  },
  A = a.div.withConfig({
    displayName: "ComponentWrapper",
    componentId: "VDS__sc-1emryhz-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  pointer-events: auto;\n"]))),
  N = a.label.withConfig({
    displayName: "HiddenLabel",
    componentId: "VDS__sc-1emryhz-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n  visibility: hidden;\n"]))),
  R = a(function (e) {
    var i = e.primitive,
      n = t(e, ["primitive"]);
    return I(i, n);
  }).withConfig({
    displayName: "StyledListItem",
    componentId: "VDS__sc-1emryhz-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  outline: none;\n  list-style: none;\n  padding-bottom: ", ";\n  padding-top: ", ";\n  width: 100%;\n  -webkit-tap-highlight-color: transparent;\n  text-decoration: none;\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var t = _ref.$paddingBottom;
    return t;
  }, function (_ref2) {
    var t = _ref2.$paddingTop;
    return t;
  }, function (_ref3) {
    var t = _ref3.surface,
      e = _ref3.$actionElement;
    return "none" === e && o(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      &:focus:not(:hover) {\n        &::before {\n          border: ", "\n            ", "\n            ", ";\n          border-radius: ", ";\n          content: '';\n          position: absolute;\n          pointer-events: none;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + 6px);\n          height: calc(100% + 6px);\n        }\n      }\n      &:focus:not(:focus-visible) {\n        &::before {\n          border: none;\n        }\n      }\n    "])), p.focusring.borderwidth.value, p.focusring.borderstyle.value, p.color.focusring["on".concat(t)].value, r(2));
  }, function (_ref4) {
    var t = _ref4.disabled,
      e = _ref4.surface,
      i = _ref4.$actionElement,
      n = _ref4.$disableClickForHitArea,
      a = _ref4.onClick;
    return !t && !n && a && o(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      &:hover {\n        cursor: pointer;\n        ", "\n      }\n      &:active {\n        ", ";\n        ", ";\n      }\n    "])), "icon" === i && "\n          .actionIconSpan button {\n            outline: none;\n            box-shadow: 0 0 0 0.0625rem ".concat(c(h.palette.gray44.value, "dark" === e ? .26 : .06), ";\n            background-color: ").concat(c(h.palette.gray44.value, "dark" === e ? .26 : .06), ";\n          "), "icon" === i && "\n          .actionIconSpan button {\n            svg {\n              path {\n                fill: ".concat(h.interactive.active["on".concat(e)].value, ";\n              }\n            }\n          }\n          "), "textLink" === i && "\n          a {\n            color: ".concat(W(e).active, ";\n            border-bottom-color: ").concat(W(e).active, ";\n          }\n          "));
  }),
  O = a.div.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-1emryhz-3"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  ", "\n"])), function (_ref5) {
    var t = _ref5.$custom,
      e = _ref5.viewport;
    return t && o(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      font-family: ", ";\n      font-size: ", ";\n      line-height: ", ";\n    "])), b.VerizonNHGeDS, "mobile" === e ? k.fontsize.title[16].value : k.fontsize.title[20].value, "mobile" === e ? k.lineheight.title[20].value : k.lineheight.title[24].value);
  }),
  j = a.span.withConfig({
    displayName: "TextContainer",
    componentId: "VDS__sc-1emryhz-4"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  ", "\n"])), function (_ref6) {
    var t = _ref6.$hasMarginLeft,
      e = _ref6.$isMobile;
    return t && "margin-left: ".concat(e ? z : D, ";");
  }),
  H = a.span.withConfig({
    displayName: "SubtitleRightWithIconContainer",
    componentId: "VDS__sc-1emryhz-5"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  text-align: end;\n  max-width: ", ";\n  padding-left: ", ";\n  overflow-wrap: break-word;\n  word-break: break-word;\n  ", "\n"])), function (_ref7) {
    var t = _ref7.$isMobile;
    return t ? "50%" : "25%";
  }, function (_ref8) {
    var t = _ref8.$isMobile;
    return t ? T : E;
  }, function (_ref9) {
    var t = _ref9.$subtitleRight;
    return !t && "padding-right: ".concat(M, ";");
  }),
  V = a.div.withConfig({
    displayName: "TextLinkContainer",
    componentId: "VDS__sc-1emryhz-6"
  })(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  max-width: ", ";\n  padding-left: ", ";\n  span:last-child {\n    height: 100%;\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: text-top;\n  }\n"])), function (_ref0) {
    var t = _ref0.$isMobile;
    return t ? "50%" : "25%";
  }, function (_ref1) {
    var t = _ref1.$isMobile;
    return t ? T : E;
  }),
  G = a.span.withConfig({
    displayName: "ToggleContainer",
    componentId: "VDS__sc-1emryhz-7"
  })(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  max-width: ", ";\n  margin-left: ", ";\n"])), function (_ref10) {
    var t = _ref10.$isMobile;
    return t ? "calc(50% - 12px)" : "calc(25% - 16px)";
  }, function (_ref11) {
    var t = _ref11.$isMobile;
    return t ? T : E;
  }),
  P = a.div.withConfig({
    displayName: "SubtitleContainer",
    componentId: "VDS__sc-1emryhz-8"
  })(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref12) {
    var t = _ref12.$paddingPosition;
    return "\n    padding-".concat(t, ": ").concat(r(m.space["1X"].value), ";\n  ");
  }),
  X = a.span.withConfig({
    displayName: "IconSectionWrapper",
    componentId: "VDS__sc-1emryhz-9"
  })(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  outline: none;\n  list-style: none;\n\n  ", "\n  ", "\n  ", "\n"])), function (_ref13) {
    var t = _ref13.surface;
    return o(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    &.active {\n      svg {\n        path {\n          fill: ", ";\n        }\n      }\n    }\n  "])), h.interactive.active["on".concat(t)].value);
  }, function (_ref14) {
    var t = _ref14.$paddingLeft;
    return t && " padding-left: ".concat(t, "; ");
  }, function (_ref15) {
    var t = _ref15.$paddingRight;
    return t && " padding-right: ".concat(t, "; ");
  }),
  K = a.span.withConfig({
    displayName: "DescriptiveIconContainer",
    componentId: "VDS__sc-1emryhz-10"
  })(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-right: ", ";\n"])), function (_ref16) {
    var t = _ref16.$isMobile;
    return t ? z : D;
  }),
  B = a.span.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "VDS__sc-1emryhz-11"
  })(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: ", ";\n"])), function (_ref17) {
    var t = _ref17.$isMobile;
    return t ? z : D;
  }),
  F = function F(t) {
    return t && C(t) && t.type && t.type.displayName ? t.type.displayName : "";
  };
var q = /*#__PURE__*/function (_ref18) {
  _inherits(q, _ref18);
  function q(t) {
    var _this;
    _classCallCheck(this, q);
    var a;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(q).call(this, t)), a = _assertThisInitialized(_assertThisInitialized(_this)), _this._getTitleAndSubTitle = function () {
      var t = a.props.children;
      if (!t) return;
      var e = function e(t) {
        var e = F(t);
        "ListGroupItemTitle" === e ? a.setState({
          listItemTitle: s(t.props.children)
        }) : "ListGroupItemSubtitle" === e && a.setState({
          listItemSubtitle: s(t.props.children)
        });
      };
      t.length > 1 ? t.forEach(function (t) {
        t && t.props && t.props.children && e(t);
      }) : e(t);
    }, _this._onActionElementClick = function () {
      a.setState(function (t) {
        return {
          selected: !t.selected
        };
      });
    }, _this._handleOnClick = function (t, e) {
      var _a$props = a.props,
        i = _a$props.onClick,
        n = _a$props.actionElement,
        o = "toggle" === n || "checkbox" === n,
        r = "toggle" === n;
      o && a._onActionElementClick(), e ? e(t, o && {
        name: t.target.name,
        selected: !a.state.selected,
        id: a.actionElementInputId
      }) : i && (r && t.preventDefault(), i(t, o && {
        name: t.target.name,
        selected: !a.state.selected,
        id: a.actionElementInputId
      }));
    }, _this._handleOnKeyDown = function (t) {
      var _a$props2 = a.props,
        e = _a$props2.onClick,
        i = _a$props2.actionElement,
        n = t.keyCode,
        o = 32 === n,
        r = 13 === n,
        c = "toggle" === i || "checkbox" === i;
      o && t.preventDefault(), c && a._onActionElementClick(), (r || o) && e && e(t, c && {
        name: a.state.listItemTitle,
        selected: !a.state.selected,
        id: a.actionElementInputId
      });
    }, _this._renderLine = function () {
      var t = a.props.surface;
      return e(f, {
        type: "secondary",
        surface: t
      });
    }, _this._renderWithIcon = function () {
      var _a$props3 = a.props,
        t = _a$props3.surface,
        i = _a$props3.viewport,
        n = _a$props3.subtitleRight,
        o = _a$props3.disabled,
        r = _a$props3.ariaRole,
        c = _a$props3.ariaHidden,
        l = _a$props3.onClick,
        s = _a$props3.icon,
        d = "mobile" === i;
      return e(X, {
        className: "actionIconSpan",
        id: "actionIconSpan",
        $paddingLeft: n && (d ? T : E),
        $paddingRight: n && M,
        surface: t,
        children: e(y, {
          "data-testid": "buttonIcon",
          kind: "ghost",
          size: "mobile" === i ? "24" : "28",
          surface: t,
          disabled: o,
          focusBorderPosition: "inside",
          fitToIcon: !0,
          "aria-hidden": c,
          tabIndex: o ? -1 : 0,
          ariaLabel: o ? void 0 : a._calculateAriaLabel(),
          ariaHidden: c,
          renderIcon: function renderIcon(t) {
            return e($, Object.assign({
              name: "right-arrow"
            }, t, {
              size: d ? 16 : "medium",
              ariaHidden: !0
            }));
          },
          onClick: function onClick(t) {
            return !o && a._handleOnClick(t, s && s.onClick ? s.onClick : void 0);
          },
          "data-analyticstrack": s && s["data-analyticstrack"],
          "data-clickstream": s && s["data-clickstream"],
          "data-sitecat-cta": s && s["data-sitecat-cta"],
          "data-sitecat-datatrack": s && s["data-sitecat-datatrack"],
          "data-sitecat-level": s && s["data-sitecat-level"],
          "data-sitecat-position": s && s["data-sitecat-position"],
          "data-track": s && s["data-track"],
          "data-track-ignore": s && s["data-track-ignore"],
          role: o ? void 0 : r || (l ? "link" : "button")
        })
      });
    }, _this._renderWithSubtitleRight = function () {
      var _a$props4 = a.props,
        t = _a$props4.subtitleRight,
        i = _a$props4.viewport,
        n = _a$props4.surface,
        o = "mobile" === i,
        r = h.elements.primary["on".concat(n)].value;
      return e(v, {
        color: r,
        size: o ? "small" : "large",
        viewport: i,
        children: t
      });
    }, _this._renderWithTextLink = function () {
      var _a$props5 = a.props,
        t = _a$props5.surface,
        i = _a$props5.disabled,
        n = _a$props5.viewport,
        o = _a$props5.textLink,
        r = "mobile" === n;
      return o && o.text ? e(V, {
        $isMobile: r,
        children: e(d, {
          type: "standAlone",
          size: r ? "small" : "large",
          surface: t,
          disabled: i,
          viewport: n,
          href: o.href ? o.href : void 0,
          role: o && o.role ? o.role : "link",
          onClick: function onClick(t) {
            t.stopPropagation(), a._handleOnClick(t, (null == o ? void 0 : o.onClick) ? o.onClick : void 0);
          },
          "data-analyticstrack": o && o["data-analyticstrack"],
          "data-clickstream": o && o["data-clickstream"],
          "data-sitecat-cta": o && o["data-sitecat-cta"],
          "data-sitecat-datatrack": o && o["data-sitecat-datatrack"],
          "data-sitecat-level": o && o["data-sitecat-level"],
          "data-sitecat-position": o && o["data-sitecat-position"],
          "data-track": o && o["data-track"],
          "data-track-ignore": o && o["data-track-ignore"],
          "data-testid": o && o["data-testid"],
          ariaLabel: i ? void 0 : a._calculateAriaLabel(),
          onKeyDown: function onKeyDown(t) {
            32 === t.keyCode && t.preventDefault();
          },
          children: o.text
        })
      }) : null;
    }, _this._renderWithToggle = function () {
      var _a$props6 = a.props,
        t = _a$props6.surface,
        i = _a$props6.disabled,
        n = _a$props6.viewport,
        o = _a$props6.toggle,
        r = "mobile" === n,
        c = o && o.statusText ? function (t) {
          return o["statusText(on)"];
        } : void 0;
      return e(G, {
        $isMobile: r,
        children: e(g, {
          on: a.state.selected,
          showText: !(o && !1 === o.showText),
          statusText: c,
          textPosition: "left",
          textSize: r ? "small" : "large",
          disabled: i,
          tabIndex: 0,
          value: o && o.value ? o.value : a.state.listItemTitle,
          name: o && o.name ? o.name : a.state.listItemTitle,
          ariaLabel: i ? void 0 : a._calculateAriaLabel(),
          inputId: o && o.inputId ? o.inputId : a.actionElementInputId,
          onChange: function onChange(t) {
            return a._handleOnClick(t, o && o.onChange ? o.onChange : void 0);
          },
          surface: t,
          "data-analyticstrack": o && o["data-analyticstrack"],
          "data-clickstream": o && o["data-clickstream"],
          "data-track": o && o["data-track"],
          "data-track-ignore": o && o["data-track-ignore"],
          "data-testid": o && o["data-testid"]
        })
      });
    }, _this._renderWithDescriptiveIcon = function () {
      var _a$props7 = a.props,
        t = _a$props7.surface,
        i = _a$props7.viewport,
        n = _a$props7.descriptiveIcon,
        o = "mobile" === i;
      return n && Object.keys(n).length && n.name ? e(K, {
        $isMobile: o,
        children: e($, {
          ariaHidden: !0,
          surface: t,
          tabIndex: -1,
          size: n && n.size ? n.size : o ? "large" : "XLarge",
          name: n.name,
          color: n.color
        })
      }) : null;
    }, _this._renderWithCheckbox = function () {
      var _a$props8 = a.props,
        t = _a$props8.viewport,
        n = _a$props8.surface,
        o = _a$props8.disabled,
        r = _a$props8.checkbox;
      return i(B, {
        $isMobile: "mobile" === t,
        children: [e(N, {
          htmlFor: a.actionElementInputId
        }), e(u, {
          customLabel: !0,
          surface: n,
          disabled: o,
          name: r && r.name ? r.name : a.state.listItemTitle,
          value: a.state.listItemTitle,
          inputId: a.actionElementInputId,
          selected: a.state.selected,
          onChange: function onChange(t) {
            return a._handleOnClick(t, r && r.onChange ? r.onChange : void 0);
          },
          ariaLabel: a._calculateAriaLabel(),
          "data-analyticstrack": r && r["data-analyticstrack"],
          "data-clickstream": r && r["data-clickstream"],
          "data-track": r && r["data-track"],
          "data-track-ignore": r && r["data-track-ignore"],
          "data-testid": r && r["data-testid"]
        })]
      });
    }, _this._renderRightSideElements = function () {
      var _a$props9 = a.props,
        t = _a$props9.actionElement,
        n = _a$props9.subtitleRight,
        o = _a$props9.viewport,
        r = "mobile" === o,
        c = "icon" === t;
      switch (t) {
        case "textLink":
          return a._renderWithTextLink();
        case "toggle":
          return a._renderWithToggle();
        case "none":
          return n ? e(H, {
            $isMobile: r,
            children: a._renderWithSubtitleRight()
          }) : null;
        case "checkbox":
          return null;
        default:
          return i(H, {
            $isMobile: r,
            $subtitleRight: n,
            children: [!!n && a._renderWithSubtitleRight(), c && a._renderWithIcon()]
          });
      }
    }, _this._renderLeftSideElements = function () {
      var t = a.props.actionElement;
      return i(n, {
        children: ["checkbox" === t && a._renderWithCheckbox(), a._renderWithDescriptiveIcon()]
      });
    }, _this._renderChildrenSlots = function () {
      var _a$props0 = a.props,
        t = _a$props0.children,
        o = _a$props0.surface,
        r = _a$props0.viewport,
        c = _a$props0.textHierarchy,
        l = "mobile" === r;
      var s, d, u;
      x.forEach(t, function (t) {
        var i = F(t);
        "ListGroupItemTitle" === i ? s = w(t, Object.assign(Object.assign({}, t.props), {
          viewport: r,
          surface: o
        })) : "ListGroupItemSubtitle" === i ? d = e(P, {
          $paddingPosition: "titleProminent" === c ? "top" : "bottom",
          children: w(t, Object.assign(Object.assign({}, t.props), {
            viewport: r,
            surface: o
          }))
        }) : "ListGroupItemImage" === i && (u = t);
      });
      return i(n, {
        children: [!!u && u, e(j, {
          $hasMarginLeft: !!u,
          $isMobile: l,
          children: s && d ? i(n, "titleProminent" === c ? {
            children: [s, d]
          } : {
            children: [d, s]
          }) : s && !d ? s : d && !s ? d : void 0
        })]
      });
    }, _this._calculateAriaLabel = function () {
      var _a$props1 = a.props,
        t = _a$props1.ariaLabel,
        e = _a$props1.subtitleRight,
        i = _a$props1.textLink,
        n = _a$props1.textHierarchy,
        o = function o() {
          return "subtitleProminent" === n && a.state.listItemSubtitle ? a.state.listItemSubtitle : a.state.listItemTitle;
        };
      return t || (e ? "".concat(a.state.listItemTitle, " ").concat(a.state.listItemSubtitle, " ").concat(e) : i ? "".concat(i.text, " ").concat(o()) : "".concat(o()));
    }, _this.actionElementInputId = "".concat(l()), _this.listItemId = "".concat(l()), _this.state = {
      selected: !1,
      listItemTitle: "",
      listItemSubtitle: ""
    };
    return _this;
  }
  _createClass(q, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._getTitleAndSubTitle();
      var _this$props = this.props,
        t = _this$props.actionElement,
        e = _this$props.toggle;
      "toggle" === t && e && e.on && this.setState({
        selected: !0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        t = _this$props2.surface,
        n = _this$props2.disabled,
        a = _this$props2.topLine,
        o = _this$props2.bottomLine,
        r = _this$props2.viewport,
        c = _this$props2.children,
        l = _this$props2.custom,
        s = _this$props2.actionElement,
        d = _this$props2.onClick,
        u = _this$props2.href,
        p = _this$props2.id,
        m = _this$props2["data-analyticstrack"],
        h = _this$props2["data-track"],
        f = _this$props2["data-track-ignore"],
        g = _this$props2["data-clickstream"],
        b = _this$props2.disableContainerHitArea,
        v = _this$props2.ariaRole,
        k = "mobile" === r,
        $ = d ? "button" : u ? "link" : void 0,
        y = "none" !== s && b;
      return i(A, {
        id: p,
        children: [a && this._renderLine(), e(R, Object.assign({
          primitive: "none" === s && u ? "a" : "div",
          "data-testid": "listClick",
          id: this.listItemId,
          "aria-label": "none" === s ? this._calculateAriaLabel() : void 0,
          role: "none" === s ? v || $ : void 0,
          $actionElement: s,
          disabled: n,
          surface: t,
          $paddingBottom: k ? S : L,
          $paddingTop: k ? S : L,
          onClick: n || y || !d ? void 0 : this._handleOnClick,
          href: u || void 0,
          tabIndex: n || "none" !== s || !d ? void 0 : 0,
          $disableClickForHitArea: y,
          "data-analyticstrack": m,
          "data-track": h,
          "data-track-ignore": f,
          "data-clickstream": g
        }, "none" === s && {
          onKeyDown: this._handleOnKeyDown
        }, {
          children: i(O, {
            $custom: l,
            viewport: r,
            children: [!l && this._renderLeftSideElements(), !l && this._renderChildrenSlots(), l && x.map(c, function (t) {
              var e = F(t);
              if (!e || "ListGroupItemImage" !== e && "ListGroupItemTitle" !== e && "ListGroupItemSubtitle" !== e) return t;
            }), !l && this._renderRightSideElements()]
          })
        })), o && this._renderLine()]
      });
    }
  }]);
  return q;
}(_);
q.componentType = "ListGroupItem", q.defaultProps = {
  actionElement: "icon",
  custom: !1,
  surface: "light",
  disabled: !1,
  topLine: !1,
  bottomLine: !1,
  textHierarchy: "titleProminent",
  onClick: void 0,
  disableContainerHitArea: !1
};
export { q as default };